document.addEventListener("DOMContentLoaded", function() {
  const row = document.querySelector(".image-text-row");
  if (!row) return;

  function startAutoScroll() {
    if (window.innerWidth > 768) return; // Only mobile
    
    let scrollAmount = 0;
    let speed = 0.6; // Adjust speed as needed

    function autoScroll() {
      scrollAmount += speed;
      row.scrollLeft = scrollAmount;

      // loop continuously
      if (scrollAmount >= row.scrollWidth - row.clientWidth) {
        scrollAmount = 0;
      }

      requestAnimationFrame(autoScroll);
    }

    autoScroll();
  }

  startAutoScroll();
  window.addEventListener("resize", startAutoScroll);
});
